<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Detalle Grupo Parametros</mat-card-title>
    </mat-card-header-->
    <mat-card-content>

        <form class="form-container"  >

            <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                    <mat-card-title>Datos Generales</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div id="container" class="formControl">
                      
                      <div class="control">
                        <mat-form-field class="imput-full-width">
                        <mat-label>Id de Grupo</mat-label>
                        <input type="text" matInput name="parameterGroup.id" [(ngModel)]="parameterGroup.id" >
                        </mat-form-field>
                    </div>
                      <div class="control">
                          <mat-form-field class="imput-full-width">
                          <mat-label>Descripción de Grupo</mat-label>
                          <input type="text" matInput name="parameterGroup.description" [(ngModel)]="parameterGroup.description" >
                          </mat-form-field>
                      </div>

                      <!--div class="control"> 
                        <button mat-flat-button class="button buttonWidth" type="button" (click)="addList()">
                          Agregar Lista
                        </button>
                      </div-->

                    </div>
                </mat-card-content>
            </mat-card>
            <br>

            <mat-card class="general-wf-card" appearance="outlined">
                <mat-card-header>
                  <mat-card-title>Parametros</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                  
                  <!--app-table #beneficiosTable [tableModel]="tableModel"></app-table-->
      
                  <table mat-table [dataSource]="parameterGroup.parameterConfigurations" class="mat-elevation-z8 table-benefits" multiTemplateDataRows>
      
                    <ng-container matColumnDef="id">
                      <th mat-header-cell *matHeaderCellDef>Id</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.id }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="objectAttributeName">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeName</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.name : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="objectAttributeAttribute">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeAttribute</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.attribute : '.' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="inOut">
                      <th mat-header-cell *matHeaderCellDef>Entrada/Salida</th>
                      <td mat-cell *matCellDef="let row" class="right-align">
                          {{ row.inOut == 'IN' ? 'Entrada' : 'Salida' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="formula">
                      <th mat-header-cell *matHeaderCellDef>Formula</th>
                      <td mat-cell *matCellDef="let row" class="right-align">
                          {{ row.formula }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="objectAttributeattribute">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeattribute</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.attribute : '' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="objectAttributeAttributeClass">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeAttributeClass</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.attributeClass : '' }}
                      </td>
                    </ng-container>
                    <!--ng-container matColumnDef="objectAttributeObjectClassRouteClass">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeObjectClassRouteClass</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.objectClass.routeClass : '.' }}
                      </td>
                    </ng-container-->
                    <ng-container matColumnDef="objectAttributeObjectClassObject">
                      <th mat-header-cell *matHeaderCellDef>objectAttributeObjectClassObject</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.objectClass.object : '.' }}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="objectAttributeObjectTypeComments">
                      <th mat-header-cell *matHeaderCellDef>Tipo Objecto</th>
                      <td mat-cell *matCellDef="let row">
                          {{ row.objectAttribute? row.objectAttribute.objectType.comments : '' }}
                      </td>
                    </ng-container>
      
                    <tr mat-header-row *matHeaderRowDef="columndefs"></tr>
                    <tr mat-row *matRowDef="let row; columns: columndefs;"></tr>
          
                  </table>
      
                </mat-card-content>
                <mat-card-footer class="general-wf-card-footer">
                </mat-card-footer>
              </mat-card>
            <br>
            
        </form>
    </mat-card-content>
</mat-card>
    